import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeatureGrid from './components/FeatureGrid';
import ComparisonSection from './components/ComparisonSection';
import ArticleHub from './components/ArticleHub';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <FeatureGrid />
      <ComparisonSection />
      <ArticleHub />
      <Testimonials />
      <CTASection />
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Hipobuy Spreadsheet Hub',
            url: 'https://hipobuyspread.hair',
            description: 'The ultimate Hipobuy Spreadsheet resource hub. Discover verified product lists, QC guides, shopping tutorials, category spreadsheets, and comparison tools.',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://kaspreadsheet.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Hipobuy Spreadsheet Hub',
            url: 'https://hipobuyspread.hair',
            logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg',
            description: 'The ultimate Hipobuy Spreadsheet resource hub providing verified product lists, QC guides, shopping tutorials, and comparison tools.',
            sameAs: [
              'https://kaspreadsheet.com',
            ],
          }),
        }}
      />
    </main>
  );
}